import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Cloud = () => {
  const solutions = [
    {
      icon: FiIcons.FiMail,
      title: 'Email Profesional',
      description: 'Cuentas de correo empresarial con su dominio personalizado.',
      isRegular: true
    },
    {
      icon: FiIcons.FiServer,
      title: 'Plan de Hosting Anual para Pymes',
      description: 'Descubre nuestra solución de hosting todo incluido, diseñada para darte la máxima tranquilidad.',
      isHighlighted: true
    },
    {
      icon: FiIcons.FiHardDrive,
      title: 'Almacenamiento Cloud',
      description: 'Soluciones de almacenamiento en la nube seguras y escalables.',
      isRegular: true
    },
    {
      icon: FiIcons.FiDatabase,
      title: 'Backup Cloud',
      description: 'Copias de seguridad automáticas en la nube.',
      isRegular: true
    }
  ];

  return (
    <div className="py-16 relative">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12">Cloud y Hosting</h1>
        
        <div className="mb-12">
          <p className="text-lg text-gray-600 mb-6">
            Lleve su negocio a la nube con nuestras soluciones de hosting y servicios cloud, diseñadas para optimizar sus operaciones y reducir costes.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {solutions.map((solution, index) => (
            <div 
              key={index} 
              className={`p-6 rounded-lg shadow-lg ${
                solution.isHighlighted 
                  ? 'bg-gradient-to-br from-blue-50 to-blue-100 border-2 border-blue-200 relative' 
                  : 'bg-white'
              }`}
            >
              {solution.isHighlighted && (
                <div className="absolute -top-3 -right-3 bg-blue-600 text-white text-xs px-3 py-1 rounded-full font-semibold">
                  ¡Destacado!
                </div>
              )}
              
              <SafeIcon 
                icon={solution.icon} 
                className={`h-12 w-12 mb-4 ${
                  solution.isHighlighted ? 'text-blue-700' : 'text-blue-600'
                }`} 
              />
              
              <h3 className={`text-xl font-semibold mb-2 ${
                solution.isHighlighted ? 'text-blue-800' : ''
              }`}>
                {solution.title}
              </h3>
              
              <p className={`mb-4 ${
                solution.isHighlighted ? 'text-blue-700' : 'text-gray-600'
              }`}>
                {solution.description}
              </p>

              {solution.isHighlighted && (
                <Link
                  to="/servicios/hosting"
                  className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors shadow-md"
                >
                  Ver Plan Detallado
                </Link>
              )}
            </div>
          ))}
        </div>

        <div className="bg-blue-50 p-8 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">Ventajas del Cloud</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start">
              <SafeIcon icon={FiIcons.FiTrendingUp} className="h-6 w-6 text-blue-600 mr-3 mt-1" />
              <div>
                <h3 className="font-semibold mb-2">Escalabilidad</h3>
                <p className="text-gray-600">Crezca según sus necesidades sin inversiones iniciales</p>
              </div>
            </div>
            <div className="flex items-start">
              <SafeIcon icon={FiIcons.FiShield} className="h-6 w-6 text-blue-600 mr-3 mt-1" />
              <div>
                <h3 className="font-semibold mb-2">Seguridad</h3>
                <p className="text-gray-600">Protección de datos y copias de seguridad automáticas</p>
              </div>
            </div>
            <div className="flex items-start">
              <SafeIcon icon={FiIcons.FiDollarSign} className="h-6 w-6 text-blue-600 mr-3 mt-1" />
              <div>
                <h3 className="font-semibold mb-2">Ahorro</h3>
                <p className="text-gray-600">Reduzca costes de infraestructura y mantenimiento</p>
              </div>
            </div>
            <div className="flex items-start">
              <SafeIcon icon={FiIcons.FiZap} className="h-6 w-6 text-blue-600 mr-3 mt-1" />
              <div>
                <h3 className="font-semibold mb-2">Rendimiento</h3>
                <p className="text-gray-600">Alta disponibilidad y velocidad de acceso</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Botón para volver arriba */}
      <button 
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all z-50"
        aria-label="Volver arriba"
      >
        <SafeIcon icon={FiIcons.FiArrowUp} className="h-6 w-6" />
      </button>
    </div>
  );
};

export default Cloud;